const steps = [
  {
    number: '01',
    icon: 'ri-checkbox-circle-line',
    title: 'Complete Your Purchase',
    description:
      'After purchasing the template pack, you will immediately receive a confirmation page and email containing your download link. This link will give you access to the full template kit.',
  },
  {
    number: '02',
    icon: 'ri-palette-line',
    title: 'Open the Canva Template Pack',
    description:
      'Click the Canva access link provided in your download folder. This will open the full set of templates directly inside Canva. No software installation is required.',
  },
  {
    number: '03',
    icon: 'ri-edit-line',
    title: 'Customize Your Post',
    description:
      'Edit the template by replacing the placeholder text and images with your own listing details, branding, and photos. You can easily change property photos, price and address, agent name and brokerage, and colors or branding. Most templates can be customized in just a few minutes.',
  },
  {
    number: '04',
    icon: 'ri-share-line',
    title: 'Download and Post',
    description:
      'Once you finish editing the template, click "Download" inside Canva and save the image. Then upload the post to Instagram, Facebook, or any social media platform. Your professional content is ready to share.',
  },
];

export default function AccessSteps() {
  return (
    <section className="py-24 px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2
            className="text-5xl font-bold text-black mb-4 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            How You Access Your Templates
          </h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto">
            Getting started takes less than 5 minutes. Follow these simple steps after purchasing the template pack.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {steps.map((step) => (
            <div
              key={step.number}
              className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-lg transition-all duration-300"
            >
              {/* Icon and Number */}
              <div className="relative mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35] rounded-full">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
                <span
                  className="absolute -top-2 -right-2 w-8 h-8 flex items-center justify-center bg-black text-white text-sm font-bold rounded-full"
                >
                  {step.number}
                </span>
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold text-black mb-3 leading-snug">
                {step.title}
              </h3>

              {/* Description */}
              <p className="text-sm text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="bg-[#FFF8F5] border border-[#FFE5D9] rounded-2xl p-6 text-center">
          <p className="text-sm text-gray-700">
            <span className="font-semibold text-black">Note:</span> All templates are fully editable and can be reused as many times as needed for future listings or content.
          </p>
        </div>
      </div>
    </section>
  );
}